import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function ShowDisabledMenu({  }) {
    const navigate = useNavigate();
    const location = useLocation();
    const isShowingDisabled = location.pathname.includes("show-disabled-events");

    const handleToggleDisabled = () => {
        if (isShowingDisabled) {
          
          navigate("..", { relative: "path" });
        } else {
        
          navigate("show-disabled-events", { relative: "path" });
        }
      };
  return (
    <div className="flex items-center">
      
        <button
        onClick={handleToggleDisabled} 
        className="flex items-center px-4 py-2 bg-gray-500 rounded-md hover:bg-gray-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-7a1 1 0 112 0v1a1 1 0 11-2 0v-1zm1-7a1.5 1.5 0 110 3A1.5 1.5 0 0110 4z"
              clipRule="evenodd"
            />
          </svg>
          {isShowingDisabled  ? "Hide disabled events" : "Show disabled events"}
        </button>
      
    </div>
  );
}

export default ShowDisabledMenu;
